<template>
  <div>
    <div class="pane-group">
      <div class="pane-sm" >
        <h5>Select Date</h5>
        <nav-item class="" v-on:click="selectReport(0)">2018-08-11</nav-item>
        <nav-item class="" v-on:click="selectReport(1)">2018-08-10</nav-item>
        <nav-item class="" v-on:click="selectReport(2)">2018-08-09</nav-item>
        <nav-item class="" v-on:click="selectReport(3)">2018-08-08</nav-item>
        
      </div>
      <div class="pane" style="padding:20px;">
        <h1>Shift Summary Report</h1>
        <table class="table-striped" style="width:300px;">
          <thead>
            <tr>
              <th v-for="value in Object.keys(list[0])" :key="value">{{value}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in list" :key="index">
              <td v-for="(data, index) in row" :key="index">
                {{data}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable indent, block-spacing */
/* global i_axios */

export default {
  name: 'ShiftSummary',
  async created () {
    var response = await i_axios.post('/getShift', { i: 0 })
    this.list = response.data
  },
  data () { return { 
      list: [{'a':1}],
      availableReports:[{i:0, date:'2018-08-01'}]
    } 
  },
  methods: {
    selectReport: async function (i) {
      var response = await i_axios.post('/getShift', { i })
      this.list = response.data
    }
  }
}
</script>

<style>
  .v2-table__row.row-hover {
    background-color: unset;
  }
  .v2-table__cell{
    height: 20px !important;
  }
  .v2-table__cell .cell{
    font-size: 10pt;
    color: black !important;
    font-family: Helvetica, Sans-Serif;
  }
  tr:hover {background-color: #f5f7fa !important;}
  .v2-table__body td .cell, .v2-table__footer td .cell {

  }
</style>
